import { Component, Input } from '@angular/core'
import { IonicModule } from '@ionic/angular'
import { TranslateModule } from '@ngx-translate/core'
import { AgentEvent } from '../../../../core/models/live-events'
import { EventComponent } from './event-component'

@Component({
  selector: 'app-agent',
  standalone: true,
  imports: [IonicModule, TranslateModule],
  template: `
    <div class="event-detail">
      <ion-text>{{ 'app.shared.event.detail.team' | translate }} : <span>{{ event?.team }}</span></ion-text>
      <ion-text>{{ 'app.shared.event.detail.tetraNumber' | translate }} : <span>{{ event?.tetraNumber }}</span>
      </ion-text>
      <ion-text>{{ 'app.shared.event.detail.arrivalDate' | translate }} : <span>{{ event?.arrivalDate }}</span>
      </ion-text>
    </div>`,
})
export class AgentComponent extends EventComponent<AgentEvent> {
  @Input() event: AgentEvent
}
